// logging and new relic labels
export const NR_PREFIX = 'REC_VEHICLES';
export const CVRE = 'CVRE';
export const VCDA = 'VCDA';
export const WIS = 'WIS';
export const IDC = 'IDC';
export const VEHICLES = 'VEHICLES';
export const CHROME_STYLE_ID = 'CHROME_STYLE_ID';
export const VDP_LINK = 'VDP_LINK';
export const VEHICLE_TITLE = 'VEHICLE_TITLE';
export const GET_PRICE = 'GET_PRICE';
export const GET_INVENTORY = 'GET_INVENTORY';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';
export const NOT_FOUND = 'NOT_FOUND';
export const FILTERED_OUT = 'FILTERED_OUT';
export const RECOMMENDATIONS = 'RECOMMENDATIONS';
export const PERSONALIZED = 'PERSONALIZED';
export const FEATURED = 'FEATURED';
export const NEW_INVENTORY = 'NEW_INVENTORY';
export const VEHICLES_WITH_NO_IMAGES = 'VEHICLES_WITH_NO_IMAGES';
export const EMPTY = 'EMPTY';
export const ADD = 'ADD';

export const CVRE_FETCH_ERROR = `${CVRE}/${FETCH_ERROR}`;
export const CVRE_RECOMMENDATIONS = `${CVRE}/${RECOMMENDATIONS}`;
export const CVRE_RECOMMENDATIONS_NOT_FOUND = `${CVRE}/${RECOMMENDATIONS}/${NOT_FOUND}`;
export const CVRE_RECOMMENDATIONS_FILTERED_OUT = `${CVRE}/${RECOMMENDATIONS}/${FILTERED_OUT}`;
export const CHROME_STYLE_ID_FETCH_ERROR = `${VCDA}/${CHROME_STYLE_ID}/${FETCH_ERROR}`;
export const PRICES_FETCH_ERROR = `${WIS}/${GET_PRICE}/${FETCH_ERROR}`;
export const VDP_LINK_FETCH_ERROR = `${WIS}/${VDP_LINK}/${FETCH_ERROR}`;
export const GET_INVENTORY_PERSONALIZED = `${WIS}/${GET_INVENTORY}/${PERSONALIZED}`;
export const GET_INVENTORY_FEATURED = `${WIS}/${GET_INVENTORY}/${FEATURED}`;
export const GET_INVENTORY_NEW_INVENTORY = `${WIS}/${GET_INVENTORY}/${NEW_INVENTORY}`;
export const GET_INVENTORY_FETCH_ERROR = `${WIS}/${GET_INVENTORY}/${FETCH_ERROR}`;
export const VEHICLE_TITLE_FETCH_ERROR = `${IDC}/${VEHICLE_TITLE}/${FETCH_ERROR}`;
export const VEHICLE_TITLE_NOT_FOUND = `${IDC}/${VEHICLE_TITLE}/${NOT_FOUND}`;
export const VDP_LINK_FETCH_NOT_FOUND = `${WIS}/${VDP_LINK}/${NOT_FOUND}`;
export const ADD_FETCH_ERROR = `ADD/${FETCH_ERROR}`;

export const STOCK_PHOTOS = 'images.dealer.com';
export const CUSTOM_PHOTOS = 'pictures.dealer.com';
